import { render } from "./SwitchinCaricati.vue?vue&type=template&id=4cb56fa4&scoped=true"
import script from "./SwitchinCaricati.vue?vue&type=script&lang=js"
export * from "./SwitchinCaricati.vue?vue&type=script&lang=js"

import "./SwitchinCaricati.vue?vue&type=style&index=0&id=4cb56fa4&lang=css"
import "./SwitchinCaricati.vue?vue&type=style&index=1&id=4cb56fa4&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb56fa4"]])

export default __exports__